import classNames from 'classnames';
import { ChevronRight } from 'lucide-react';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import i18n from '@/settings/i18n';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';

const t = i18n.init('product');

const FrequentlyAskedQuestionsSlider = dynamic(
  () => import('./FrequentlyAskedQuestionsSlider'),
  { ssr: false },
);

const FrequentlyAskedQuestions = () => {
  const [showModal, setShowModal] = useState(false);

  const { product } = useProductPageContext();

  // Product FAQs
  const faqs = product?.faq ?? [];

  // Don't render if no FAQs
  if (!faqs.length) {
    return null;
  }

  return (
    <>
      <button
        className={classNames(
          '-mt-px flex w-full items-center justify-between border-t p-4 text-left font-medium hover:underline focus:outline-none',
        )}
        onClick={() => {
          setShowModal(!showModal);
        }}
      >
        <h2>{t`Frequently Asked Questions`}</h2>
        <ChevronRight className="h-5 w-5 shrink-0" />
      </button>
      <FrequentlyAskedQuestionsSlider
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  );
};

export default FrequentlyAskedQuestions;
